import { Button, CircularProgress, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Colors } from 'src/shared/components/styles';
import { ProjectStatusEnum } from 'src/shared/enums/projectStatus.enum';
import { isSustainabilityEditorUserOrAdmin } from 'src/shared/helpers/permissionHelper';
import { SustainabilityReportResponse } from 'src/shared/services/api/response/sustainabilityReportResponse';
import { RootStateType } from 'src/shared/services/redux/reducers';

type SustainabilitySubmitButtonProps = {
  status: number;
  readyForApprovalDisabled: boolean;
  report: SustainabilityReportResponse;
  showReadyForApprovalDisabledTooltip: boolean;
  onClickSubmit: () => void;
};

export const SustainabilitySubmitButton = (
  props: SustainabilitySubmitButtonProps,
) => {
  const {
    status,
    readyForApprovalDisabled,
    showReadyForApprovalDisabledTooltip,
    onClickSubmit,
    report,
  } = props;
  const { t } = useTranslation();
  const { userDetails } = useSelector(
    (state: RootStateType) => state.authState,
  );
  // const isSuperAdmin =
  //   userDetails?.permissionGroup.id === UserTypeEnum.SuperAdmin;
  return (
    <>
      {(status === ProjectStatusEnum.Created ||
        status === ProjectStatusEnum.SupplementRequested) && (
        <Tooltip
          title={
            showReadyForApprovalDisabledTooltip
              ? `${t('noPermissionToFinalizeReport')}`
              : `${t('emailToResponsibleReviewer')}`
          }
          arrow
        >
          <span>
            <Button
              variant='contained'
              sx={{
                fontSize: 12,
                backgroundColor: Colors.BADGE_YELLOW,
                color: 'text.primary',
                ':hover': {
                  backgroundColor: Colors.BADGE_YELLOW,
                  color: 'text.primary',
                },
              }}
              type='button'
              onClick={onClickSubmit}
              disabled={
                readyForApprovalDisabled ||
                !isSustainabilityEditorUserOrAdmin(userDetails, report)
              }
              startIcon={
                readyForApprovalDisabled ? (
                  <CircularProgress size={16} color='inherit' />
                ) : undefined
              }
            >
              {t('markAsReadyForApproval')}
            </Button>
          </span>
        </Tooltip>
      )}
    </>
  );
};
